{
	"accounts": "Cuentas",
	"invitations": "Invitaciones",
	"subscribeToFeedback": "Suscríbete al programa de comentarios",
	"notificationSettings": {
		"title": "Configuración de notificaciones por correo",
		"invoicingInformation": "Información de facturación",
		"declarationProcessingStatus": "Estado de procesamiento de declaración",
		"enabled": "Activado",
		"disabled": "Desactivado",
		"toast": {
			"success": "Preferencia de notificación actualizada",
			"error": "Error al actualizar la preferencia de notificación"
		}
	},
	"about": {
		"title": "Acerca de",
		"termsAndConditions": "Términos y condiciones",
		"privacyPolicy": "Política de privacidad",
		"imprint": "Aviso legal",
		"openSourceAttribution": "Atribución de código abierto"
	},
	"language": {
		"title": "Idioma",
		"footer": "Los cambios de idioma se propagarán a todas las aplicaciones de Heidelberg Materials"
	},
	"impressum": "Aviso legal",
	"copyright": "© 2024 Heidelberg Materials. Reservados todos los derechos.",
	"login": "Acceso",
	"logout": "Cerrar sesión"
}
